import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

const matchDateOnly = new RegExp(/(?<year>\d{4})-(?<month>\d{1,2})-(?<day>\d{1,2})/);

@Pipe({
  name: 'localDate',
  standalone: false
})
export class LocalDatePipe implements PipeTransform {
  private defaultFormat = 'MM/DD/YYYY h:mm:ss A';
  transform(date: string | Date, format: string = this.defaultFormat): string {
    if (!date) {
      return '';
    }

    const isDateOnly = typeof date === 'string' ? matchDateOnly.test(date) : false;
    //don't convert date-only with moment.utc because that will "move" the date as the day before
    //because midnight UTC is technically the day before for timezones in western hemisphere
    const momentObj = isDateOnly ? moment(date) : moment.utc(date, 'YYYY-MM-DD H:m:s').local();
    return momentObj.format(format);
  }
}
